import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';

export async function fetchAccounts({ commit, state }, text) {
    await $http
        .get("/api/cuentas-lite",{ params : {filter:text}})
        .then(response => {
            commit("setAccounts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function fetchContactsLite({ commit, state }) {

    switch (state.params.contact_type) {
            case 'Cliente':
                state.params_contacts_lite.type = "is_customer";
                break;
            case 'Proveedor':
                state.params_contacts_lite.type = "is_provider";
                break;
            case 'Empleado':
                state.params_contacts_lite.type = "is_employee";
                break;
        }

    let params = {
        params: state.params_contacts_lite
    };

    await $http
        .get("/api/terceros-lite", params)
        .then(response => {
            commit("setContactsLite", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchContactBalanceReport({ commit, state }) {
    state.loading.module = true;
    await $http
        .get("/api/reporte-balance-tercero", {params: state.params})
        .then(response => {
            commit("setReportData", response.data.data);
            state.loading.module = false;
        })
        .catch(error => {
            state.loading.module = false;
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/contact-balance/actions.js